import preview from "../../../dashboard/program-library/program-preview.controller";

const ProgramPreview = (app) => {
  app.get("/program-preview/:cycleId", preview);
};

export default ProgramPreview;
